import { RemoveCircleOutline } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetCustomerData } from "../../../APIServices/SalesService/OrderService/OrderThunk";
import { HashLoader } from "react-spinners";
import toast, { Toaster } from "react-hot-toast";
import {
  commonFilter,
  getUniqueFilteredData,
} from "../../../SharedFiles/Helper/utils";
import CommonRadio from "../../../SharedFiles/CommonRadio/CommonRadio";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import SearchBar from "../SalesShared/SearchBar/SearchBar";
import { FaChevronRight } from "react-icons/fa6";
import { BsCart4 } from "react-icons/bs";
import useOrderLogic from "./UserOrderFunction";
import "./OrderPage.css";
const CheckOut = ({
  setIsCheckout,
  InProgress,
  setCartItems,
  openModal,
  setInProgress,
  cartItems,
  removeFromCart,
  setCustomerData,
  customerData,
  setAttachments,
  attachments,
  customerForm,
  setCustomerForm,
  showItemData,
  setShowItemData,
  itemGroupFlag,
  editing,
  setEditing,
}) => {
  // const {setAttachments,attachments
  // } = useOrderLogic;
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [AddressValue, setAddressValue] = useState([]);
  // const [custData, setCustData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  const [focusFlag, setFocusFlag] = useState(false);
  const inputRef = useRef(null);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const { CustomerData, error, loading,documentType} = useSelector((state) => state.order);
  const isLoading = () => loading.CustomerData;
  useEffect(() => {
    if (CustomerData) {
      const uniqueCustomers = getUniqueFilteredData(CustomerData, "card_Code");
      setFilteredCustomers(uniqueCustomers);
      // setCustData(CustomerData);
    } else {
      setFilteredCustomers([]);
    }
  }, [CustomerData]);

  useEffect(() => {
    if (focusFlag && inputRef.current) {
      inputRef.current.focus();
      setFocusFlag(false);
    }
  }, [focusFlag]);
  const checker = () => {
    if (!editing && InProgress.fetchCustomer && error.CustomerDataError) {
      const errorss = error.CustomerDataError;
      const status = errorss.errorCode;
      const errormessage = errorss.errorMessage;
      setInProgress({ ...InProgress, fetchCustomer: false });
      if (status === 404) {
        return null;
      } else {
        toast.error(errormessage);
      }
      setFocusFlag(true);
    }
    // if (!editing&&InProgress.PostSQ) {
    //   if (error.PostSaleSQError) {
    //     const errorss = error.PostSaleSQError;
    //     const status = errorss.errorCode;
    //     if (status) {
    //       toast.error(errorss.errorMessage);
    //     } else {
    //       toast.error("Error occur while Posting a Data");
    //     }
    //     setInProgress({ ...InProgress, PostSQ: false });
    //   }
    // }
  };
  useEffect(() => {
    checker();
  }, [CustomerData, loading, error, InProgress]);

  const handleOpenCustomerModal = () => {
    setInProgress({ ...InProgress, fetchCustomer: true });
    dispatch(GetCustomerData({ SEARCHTEXT: "" }));
    setIsCustomerModalOpen(true);
  };

  const handleCloseCustomerModal = () => {
    setIsCustomerModalOpen(false);
    setShowDropdown(false);
    setCustomerName("");
    setAddressValue([]);
  };

  const handleCustomerSelect = (customer) => {
    setCustomerData(customer);
    setCustomerName(`${customer.card_Code}-${customer.card_Name}`);
    setAddressValue([
      {
        headerAddress: customer.header_Address,
        address: customer.address,
      },
    ]);
    setShowDropdown(false);
  };

  const handleCustomerInputChange = (e) => {
    const inputValue = e.target.value;
    setCustomerName(inputValue);
    setShowDropdown(true);
    if (inputValue.length > 1) {
      if (debounceTimeout) clearTimeout(debounceTimeout);
      const timeout = setTimeout(() => {
        setInProgress({ ...InProgress, fetchCustomer: true });
        dispatch(GetCustomerData({ SEARCHTEXT: inputValue }));
      }, 500);
      setDebounceTimeout(timeout);
    }
  };

  const handleRadioChange = (option) => {
    setCustomerForm((prev) => ({
      ...prev,
      addressShort: option.label, // used elsewhere as needed
    }));
  };
  const handleSubmitCustomer = () => {
    if (!customerData?.card_Code) {
      toast.error("Customer data is required to proceed!");
      return;
    }
    if (!customerForm.addressShort) {
      toast.error("Address is required to proceed!");
      return;
    }
    setCustomerForm((prev) => ({
      ...prev,
      customerName: `${customerData.card_Code} - ${customerData.card_Name}`,
      address:
        customerData.header_Address +
        (customerData.address ? ` - ${customerData.address}` : ""),
      contactNumber: customerData.contact_Number || "",
      customerCode: customerData.card_Code,
    }));
    setIsCustomerModalOpen(false);
    setCustomerName("");
    setAddressValue([]);
  };

  const handleBackItemGrp = () => {
    if (editing) {
      setEditing(false);
      localStorage.removeItem("Edit");
      sessionStorage.removeItem("cartItems");
    } else {
      setIsCheckout(false);
      // setshowAddress("");
      // setRemarks("");
    }
  };


  const handlePriorityChange = (itemCode) => {
    const priorityCount = cartItems.filter((item) => item.priority).length;
    if (
      priorityCount >= 8 &&
      !cartItems.find((i) => i.item_Code === itemCode)?.priority
    ) {
      toast.error("You can only select up to 8 items with priority.");
      return;
    }
    const updatedCartItems = cartItems.map((item) =>
      item.item_Code === itemCode ? { ...item, priority: !item.priority } : item
    );

    setCartItems(updatedCartItems);
    sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
  };
  const radioOptions = AddressValue?.map((address) => ({
    label: `${address.headerAddress}`,
    value: `${address.address}`,
  }));
  const inputFieldLabel = [
    {
      label: "Select Customer",
      key: "customerName",
      type: "input",
      onClick: () => {
        if (editing) {
          setIsCustomerModalOpen(false);
        } else {
          handleOpenCustomerModal();
        }
      },
    },
    {
      label: "Address",
      key: "address",
      type: "input",
      readOnly: true,
    },
    {
      label: "Contact Number",
      key: "contactNumber",
      type: "input",
      readOnly: true,
    },
    ...(!editing
      ? [
          {
            label: "Document Type",
            key: "docType",
            type: "dropdown",
            options: [
              { value: "", label: "Select Document Type" },
              ...(documentType?.map((item) => ({
                value: item.fldValue,
                label: item.descr,
              })) || []),
            ],
            readOnly: false,
          },
        ]
      : []),,
    {
      label: "Instruction",
      key: "remarks",
      type: "textarea",
      readOnly: false,
    },
    { label: "Customerpo", key: "poNum", type: "text", readOnly: false },
  ];
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const imagePreviews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setAttachments((prev) => [...prev, ...imagePreviews]);
  };

  // const removeImage = (index) => {
  //   setAttachments((prev) => {
  //     const newImages = [...prev];
  //     // Revoke preview URL to free memory
  //     URL.revokeObjectURL(newImages[index].preview);
  //     newImages.splice(index, 1);
  //     return newImages;
  //   });
  // };
  const removeImage = (index) => {
    setAttachments((prev) => {
      const newImages = [...prev];
      URL.revokeObjectURL(newImages[index].preview);
      newImages.splice(index, 1);

      if (newImages.length === 0 && fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      return newImages;
    });
  };

  return (
    <div className="checkoutmain">
      <div className="checkback">
        <button className="SalesBackButton" onClick={handleBackItemGrp}>
          <IoMdArrowRoundBack className="backicon" />
          <p className="item">Back</p>
        </button>
        <h6 className="item">CHECKOUT</h6>
      </div>
      <div className="checkoutproduct">
        <div className="SearchContiner position-relative">
          {editing && (
            <SearchBar
              showItemData={showItemData}
              setShowItemData={setShowItemData}
              itemGroupFlag={itemGroupFlag}
              InProgress={InProgress}
              setInProgress={setInProgress}
              cartItems={cartItems}
              openModal={openModal}
              removeFromCart={removeFromCart}
            />
          )}
        </div>
        {!showItemData && (
          <>
            <div className="checkheader">
              <div className="priority-header">PRIORITY</div>
              <div className="product-header text-center flex-grow-1">
                PRODUCTS
              </div>
              <div className="qty-header text-end">BUNDLES</div>
            </div>
            <ul className="lineborder pt-2">
              {cartItems?.length > 0 ? (
                cartItems.map((data, index) => (
                  <li key={index} className="cart-item">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={data.priority || false}
                      onChange={() => handlePriorityChange(data.item_Code)}
                    />
                    <div className="groupSize align-items-center">
                      <div
                        className="removeicon"
                        onClick={() => removeFromCart(data.item_Code)}
                      >
                        <RemoveCircleOutline />
                      </div>
                      <div className="itmlist">
                        <p className="itemcode item">{data.item_Name}</p>
                        <span className="itemname item">
                          {data.height?.toFixed(2)} mm
                        </span>
                        <p className="itemcode item">{data.item_Code}</p>
                      </div>
                    </div>
                    <div
                      className="quantityDisplay AddCart"
                      onClick={() => openModal(data)}
                    >
                      <p className="item">
                        {data.type === "bundle"
                          ? data.quantity
                          : data.quantityNos}
                      </p>
                    </div>
                  </li>
                ))
              ) : (
                <p className="no-orders-message">No items in cart</p>
              )}
            </ul>
            <div className="userDetaislDiv">
              {/* {inputFieldLabel.map((field, index) => (
                <div key={index}>
                  <div className="headertext">
                    <p className="item">{field.label}</p>
                  </div>
                  <div className="select-customer">
                    {field.type === "textarea" ? (
                      <textarea
                        value={customerForm[field.key]}
                        onChange={(e) =>
                          setCustomerForm((prev) => ({
                            ...prev,
                            [field.key]: e.target.value,
                          }))
                        }
                        placeholder={field.label}
                        className={`customer-input ${!editing && !field.readOnly ? 'editable' : 'readonly'}`}
                      />
                    ) : (
                      
                      // <input
                      //   type="text"
                      //   value={customerForm[field.key]}
                      //   onClick={field.onClick}
                      //   onChange={
                      //     isEditable
                      //       ? (e) =>
                      //         setCustomerForm((prev) => ({
                      //           ...prev,
                      //           [field.key]: e.target.value,
                      //         }))
                      //       : undefined
                      //   }
                      //   placeholder={field.label}
                      //   className={`customer-input ${isEditable ? 'editable' : 'readonly'}`}
                      //   readOnly={!isEditable}
                      // />
                      <input
                        type="text"
                        value={customerForm[field.key]}
                        onClick={field.onClick}
                        onChange={
                          field.key === "poNum"
                            ? (e) =>
                                setCustomerForm((prev) => ({
                                  ...prev,
                                  [field.key]: e.target.value,
                                }))
                            : undefined
                        }
                        placeholder={field.label}
                        className={`customer-input ${!editing&&!field.readOnly ? 'editable' : 'readonly'}`}
                        readOnly={field.readOnly}
                      />
                    )}
                  </div>
                </div>
              ))} */}
              {/* {inputFieldLabel.map((field, index) => {
                const isEditable =
                  field.key === "remarks" || (!editing && !field.readOnly);

                return (
                  <div key={index}>
                    <div className="headertext">
                      <p className="item">{field.label}</p>
                    </div>
                    <div className="select-customer">
                      {field.type === "textarea" ? (
                        <textarea
                          value={customerForm[field.key]}
                          onChange={
                            isEditable
                              ? (e) =>
                                setCustomerForm((prev) => ({
                                  ...prev,
                                  [field.key]: e.target.value,
                                }))
                              : undefined
                          }
                          placeholder={field.label}
                          className={`customer-input ${isEditable ? "editable" : "readonly"}`}
                          readOnly={!isEditable}
                        />
                      ) : (
                        <input
                          type="text"
                          value={customerForm[field.key]}
                          onClick={field.onClick}
                          onChange={
                            isEditable
                              ? (e) =>
                                setCustomerForm((prev) => ({
                                  ...prev,
                                  [field.key]: e.target.value,
                                }))
                              : undefined
                          }
                          placeholder={field.label}
                          className={`customer-input ${isEditable ? "editable" : "readonly"}`}
                          readOnly={!isEditable}
                        />
                      )}
                    </div>
                  </div>
                );
              })} */}
              {inputFieldLabel.map((field, index) => {
                const isEditable =
                  field.key === "remarks" || (!editing && !field.readOnly);

                return (
                  <div key={index}>
                    <div className="headertext">
                      <p className="item">{field.label}</p>
                    </div>
                    <div className="select-customer">
                      {field.type === "textarea" ? (
                        <textarea
                          value={customerForm[field.key]}
                          onChange={
                            isEditable
                              ? (e) =>
                                  setCustomerForm((prev) => ({
                                    ...prev,
                                    [field.key]: e.target.value,
                                  }))
                              : undefined
                          }
                          placeholder={field.label}
                          className={`customer-input ${
                            isEditable ? "editable" : "readonly"
                          }`}
                          readOnly={!isEditable}
                        />
                      ) : field.type === "dropdown" ? (
                        <select
                          value={customerForm[field.key]}
                          onChange={
                            isEditable
                              ? (e) =>
                                  setCustomerForm((prev) => ({
                                    ...prev,
                                    [field.key]: e.target.value,
                                  }))
                              : undefined
                          }
                          className={`customer-input ${
                            isEditable ? "editable" : "readonly"
                          }`}
                          disabled={!isEditable}
                        >
                          {field.options?.map((option, idx) => (
                            <option key={idx} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          value={customerForm[field.key]}
                          onClick={field.onClick}
                          onChange={
                            isEditable
                              ? (e) =>
                                  setCustomerForm((prev) => ({
                                    ...prev,
                                    [field.key]: e.target.value,
                                  }))
                              : undefined
                          }
                          placeholder={field.label}
                          className={`customer-input ${
                            isEditable ? "editable" : "readonly"
                          }`}
                          readOnly={!isEditable}
                        />
                      )}
                    </div>
                  </div>
                );
              })}

              {!editing && (
                <div className="image-upload-section">
                  <label
                    className="headertext item"
                    htmlFor="image-upload-input"
                  >
                    Upload PO Images
                  </label>

                  <input
                    id="image-upload-input"
                    type="file"
                    accept="image/*"
                    multiple
                    ref={fileInputRef}
                    onChange={handleImageChange}
                    className="image-upload-input"
                  />

                  <div className="preview-container">
                    {attachments &&
                      attachments.map((img, index) => (
                        <div key={index} className="preview-item">
                          <img
                            src={img.preview}
                            alt={`preview-${index}`}
                            className="preview-image"
                          />
                          <button
                            className="remove-btn"
                            onClick={() => removeImage(index)}
                            aria-label={`Remove image ${index + 1}`}
                            type="button"
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <Dialog open={isCustomerModalOpen} onClose={handleCloseCustomerModal}>
        <DialogTitle className="Modal-heading">Select Customer</DialogTitle>
        <DialogContent className="salesDialog">
          <input
            ref={inputRef}
            type="text"
            value={customerName}
            onClick={() => setShowDropdown(true)}
            onChange={handleCustomerInputChange}
            placeholder="Enter Customer Name"
            className="customer-input w-100"
          />
          {showDropdown && (
            <div className="dropdown">
              <ul className="customerUl">
                {filteredCustomers.length > 0 ? (
                  filteredCustomers.map((customer, index) => (
                    <li
                      key={index}
                      onClick={() => handleCustomerSelect(customer)}
                      className="dropdown-item"
                    >
                      {customer.card_Code} - {customer.card_Name}
                    </li>
                  ))
                ) : (
                  <li className="dropdown-item text-muted text-center">
                    No data found
                  </li>
                )}
              </ul>
            </div>
          )}

          {radioOptions?.length > 0 && (
            <CommonRadio
              label="Select Address"
              options={radioOptions}
              selectedValue={customerForm.addressShort}
              handleRadioChange={handleRadioChange}
            />
          )}
        </DialogContent>
        <DialogActions className="custom-dialog-actions">
          <Button onClick={handleCloseCustomerModal} className="Modal-cancel">
            Cancel
          </Button>
          <Button onClick={handleSubmitCustomer} className="Modal-submit">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {isLoading() && (
        <div className="loader-sales">
          <HashLoader color="#ed1c24" />
        </div>
      )}
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
    </div>
  );
};

export default CheckOut;
